import { getStorage } from 'firebase/storage';
import { app } from '../../config/firebase';

export const storage = getStorage(app);
